"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signData = void 0;
const keyManager_1 = require("../keyManager");
const md5 = require('md5');
const signData = async (data) => {
    await (0, keyManager_1.generateKeys)();
    const jsonString = JSON.stringify(data).replace(/["',.\s]/g, '');
    const dataBuffer = new TextEncoder().encode(md5(jsonString));
    const signature = await window.crypto.subtle.sign({
        name: "RSASSA-PKCS1-v1_5",
        saltLength: 32,
    }, (0, keyManager_1.getPrivateKey)(), dataBuffer);
    const signatureArray = Array.from(new Uint8Array(signature));
    const base64Signature = window.btoa(String.fromCharCode.apply(null, signatureArray));
    return {
        ...data,
        signature: base64Signature,
        validation: window.btoa((0, keyManager_1.getPublicKey)())
    };
};
exports.signData = signData;
